'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const DOTS = '...';
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};
const usePagination = (totalPageCount, currentPage, isMobile) => {
    const paginationRange = React__namespace.useMemo(() => {
        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;
        const totalPageNumbers = isMobile ? 5 : 7;
        if (totalPageCount === 1) {
            return [];
        }
        if (isMobile) {
            if (totalPageNumbers >= totalPageCount) {
                return range(1, totalPageCount);
            }
            if (currentPage < 1) {
                return [...range(firstPageIndex, 3), DOTS, lastPageIndex];
            }
            if (currentPage === 1) {
                return [...range(1, 4), DOTS, lastPageIndex];
            }
            if (currentPage === 8) {
                return [firstPageIndex, DOTS, ...range(lastPageIndex - 3, lastPageIndex)];
            }
            if (currentPage > lastPageIndex - 3) {
                return [firstPageIndex, DOTS, ...range(lastPageIndex - 2, lastPageIndex)];
            }
            return [firstPageIndex, DOTS, ...range(currentPage, currentPage + 2), `${DOTS}_2`, lastPageIndex];
        }
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        if (currentPage < 3) {
            return [...range(firstPageIndex, 5), DOTS, lastPageIndex];
        }
        if (currentPage === 3) {
            return [...range(1, 6), DOTS, lastPageIndex];
        }
        if (currentPage === lastPageIndex - 4) {
            return [firstPageIndex, DOTS, ...range(lastPageIndex - 5, lastPageIndex)];
        }
        if (currentPage > lastPageIndex - 5) {
            return [firstPageIndex, DOTS, ...range(lastPageIndex - 4, lastPageIndex)];
        }
        return [firstPageIndex, DOTS, ...range(currentPage - 1, currentPage + 3), `${DOTS}_2`, lastPageIndex];
    }, [isMobile, totalPageCount, currentPage]);
    return paginationRange;
};

exports.usePagination = usePagination;
//# sourceMappingURL=usePagination.js.map
